import script from "./inputCode.vue?vue&type=script&setup=true&lang=js"
export * from "./inputCode.vue?vue&type=script&setup=true&lang=js"

import "./inputCode.vue?vue&type=style&index=0&id=5c727b26&lang=scss&scoped=true"

import exportComponent from "D:\\a-mydemo\\houlang\\gs-demo\\keymemo-demo\\keymemory-pc-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c727b26"]])

export default __exports__